import { List, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { useFundingApplication, useFundingApplicationMutation } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { useStageOptOutCheckbox } from "../hooks";

import { DocumentUpload } from "./document-upload";
import { MESSAGES } from "./message-definitions";

export const PoolBancarioDocumentUpload = ({
  includeHeader = false,
  error,
}: {
  includeHeader?: boolean;
  error?: string;
}): UIElement => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const { data: fundingApplication } = useFundingApplication(customerDomain);
  const fundingApplicationMutation = useFundingApplicationMutation(customerDomain);
  const { useLegacyCheckbox, canOptOutOfStage } = useStageOptOutCheckbox(UploadDocumentType.POOL_BANCARIO);

  const handleSkipCheckbox = async (checked: boolean) => {
    await fundingApplicationMutation.mutateAsync({ id: fundingApplication.id, isPoolBancarioSkipped: checked });
  };

  return (
    <DocumentUpload
      documentType={UploadDocumentType.POOL_BANCARIO}
      supportedFileExtensions={[".xlsx"]}
      fileSizeLimitMB={10}
      header={includeHeader ? intl.formatMessage(MESSAGES.poolBancarioTitle) : undefined}
      description={
        <List type="bullet">
          <List.Item>
            <Text>{intl.formatMessage(MESSAGES.poolBancarioDescriptionPoint1)}</Text>
          </List.Item>
          <List.Item>
            <Text>{intl.formatMessage(MESSAGES.poolBancarioDescriptionPoint2)}</Text>
          </List.Item>
        </List>
      }
      onSkipCheckbox={useLegacyCheckbox ? handleSkipCheckbox : canOptOutOfStage ? handleSkipCheckbox : undefined}
      skipped={fundingApplication.isPoolBancarioSkipped}
      error={error}
    />
  );
};
